import React, { useState } from "react";
import "./ImportantDateAddOrUpdatePopup.css";

interface Props {
  handleClose: any;
  handleConfirmation: any;
  item?: any;
}

export const IMPORTANT_DATE_TYPES = [
  { value: "svatek", label: "Svátek", icon: "fas fa-birthday-cake" },
  { value: "narozeniny", label: "Narozeniny", icon: "fas fa-gift" },
  { value: "vyroci", label: "Výročí", icon: "fas fa-heart" },
];

const toDateInputValue = (value: any) => {
  const date = value ? new Date(value) : new Date();
  if (isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const ImportantDateAddOrUpdatePopup = (props: Props) => {
  const isEdit = !!(props.item && props.item.importantDateId);

  const [firstName, setFirstName] = useState<string>(
    props.item?.firstName ?? ""
  );
  const [lastName, setLastName] = useState<string>(props.item?.lastName ?? "");
  const [title, setTitle] = useState<string>(props.item?.title ?? "");
  const [type, setType] = useState<string>(props.item?.type ?? "narozeniny");
  const [date, setDate] = useState(toDateInputValue(props.item?.date));
  const [description, setDescription] = useState<string>(
    props.item?.description ?? ""
  );

  const isValid = firstName.trim() !== "" || title.trim() !== "";

  const handleSave = () => {
    if (!isValid) {
      return;
    }

    props.handleConfirmation({
      importantDateId: props.item?.importantDateId ?? 0,
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      title: title.trim(),
      type,
      date: date || toDateInputValue(new Date()),
      description: description.trim(),
    });
  };

  return (
    <div className="idPopupRoot">
      <div className="idOverlay" onClick={props.handleClose}></div>

      <div className="idModal">
        <div className="idModal__header">
          <div className="idModal__title">
            <i className="far fa-calendar-check"></i>
            {isEdit ? "Úprava události" : "Nová událost"}
          </div>
          <button
            className="idModal__close"
            onClick={props.handleClose}
            type="button"
            aria-label="Zavřít"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="idModal__body">
          <div className="idField">
            <label>Typ události</label>
            <div className="idTypeChips">
              {IMPORTANT_DATE_TYPES.map((dateType) => (
                <button
                  key={dateType.value}
                  type="button"
                  className={
                    "idTypeChip" + (type === dateType.value ? " active" : "")
                  }
                  onClick={() => setType(dateType.value)}
                >
                  <i className={dateType.icon}></i> {dateType.label}
                </button>
              ))}
            </div>
          </div>

          <div className="idRow">
            <div className="idField">
              <label htmlFor="idFirstName">Jméno</label>
              <input
                type="text"
                id="idFirstName"
                placeholder="např. Jan"
                value={firstName}
                onChange={(event) => setFirstName(event.target.value)}
              />
            </div>
            <div className="idField">
              <label htmlFor="idLastName">Příjmení</label>
              <input
                type="text"
                id="idLastName"
                placeholder="např. Novák"
                value={lastName}
                onChange={(event) => setLastName(event.target.value)}
              />
            </div>
          </div>

          <div className="idField">
            <label htmlFor="idTitle">Název události</label>
            <input
              type="text"
              id="idTitle"
              placeholder="např. 30. narozeniny"
              value={title}
              onChange={(event) => setTitle(event.target.value)}
            />
          </div>

          <div className="idField">
            <label htmlFor="idDate">Datum</label>
            <input
              type="date"
              id="idDate"
              value={date}
              onChange={(event) => setDate(event.target.value)}
            />
          </div>

          <div className="idField">
            <label htmlFor="idDescription">Popis</label>
            <textarea
              id="idDescription"
              rows={3}
              placeholder="Poznámka k události…"
              value={description}
              onChange={(event) => setDescription(event.target.value)}
            />
          </div>
        </div>

        <div className="idModal__footer">
          <button
            type="button"
            className="idBtn idBtn--ghost"
            onClick={props.handleClose}
          >
            Storno
          </button>
          <button
            type="button"
            className="idBtn idBtn--primary"
            disabled={!isValid}
            onClick={handleSave}
          >
            <i className="fas fa-check"></i>
            {isEdit ? "Uložit" : "Přidat"}
          </button>
        </div>
      </div>
    </div>
  );
};
